import { ChallengeAboutFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { ChallengeAboutSection } from '../../../../../../interfaces/SaveChallengeInfo';
import { challengeService } from '../../../../../../services/challengeService';

export const transformAboutToFormValues = (
  about: ChallengeAboutSection,
): { about: ChallengeAboutFormValues } => {
  return {
    about: {
      challengeName: about.challengeName,
      scoringRules: about.scoringRules ?? '',
      customerType: about.customerType ?? '',
      price: about.price ?? '',
      description: about.description ?? '',
      divisions: about.divisions ?? [],
      about: about.about ?? '',
      additionalInfo: about.additionalInfo ?? '',
    },
  };
};

export const getAboutFormValue = async (
  challengeId: number,
): Promise<{ about: ChallengeAboutFormValues }> => {
  const about = await challengeService.getChallengeAbout(challengeId);
  return transformAboutToFormValues(about);
};
